import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import makeStyles from '@mui/styles/makeStyles';
import cn from "classnames";
import DJRListItem from "components/djr/DJRListItem";
import { formatDate } from 'utils/strUtils';
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    position: 'relative',
    overflow: 'auto',
  },
  ul: {
    padding: 0
  },
  subheader: {
    // backgroundColor: theme.palette.background.paper,
  }
}));

export default function DJRList({ djrs = {}, height, onItemSelect, className }) {
  const classes = useStyles();

  const dates = Object.keys(djrs).sort().reverse();;

  const handleClick = (tx) => () => !!onItemSelect && onItemSelect(tx);
  const listClasses = cn(classes.root, className);
  const toSection = (dateKey, i) => {
    const dayDJRs = djrs[dateKey];
    const [{ date }] = dayDJRs;
    return (
      <li key={dateKey}>
        <ul className={classes.ul}>
          <ListSubheader className={classes.subheader} disableGutters data-testid='label-date'>{formatDate(date)}</ListSubheader>
          {dayDJRs.map(tx =>
            <DJRListItem
              key={tx.qDJRId}
              djr={tx}
              onClick={handleClick(tx)}
            />
          )}
        </ul>
      </li>
    )
  };


  return (
    <List className={listClasses} style={{ height }} subheader={<li />} dense>
      {dates.map(toSection)}
    </List>
  );
}
